<template>

  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-card>
      <b-row>
        <b-col cols="12">
          <b-card>

            <b-row class="m-0 p-0" style="color: var(--color-dentalia); font-size: 20px; font-weight: bold; border-bottom: 3px solid; border-color: rgb(68, 173, 248); !important">
              <b-col class="text-left m-0 p-0">
                <span>
                  Administración de planes y convenios
                </span>
              </b-col>
              <b-col class="text-right m-0 p-0">
                <div>Admin_Plan_Convenio</div>
              </b-col>
            </b-row>

            <b-row class="pt-3 pb-3">
              <b-col>
                <b-row align="center">
                  <b-col></b-col>
                  <div style="min-width: 350px; flex: 1;margin-right: 0px; margin-top: 0px;">
                    <div class="barra-plan" style="margin-top: 10px;">
                      <div style="flex:1; display: flex;" >
                        <div style="display: contents;">
                            <b-form-input
                                class="input-filter"
                                v-model="filtro.palabraClave"
                                placeholder="Busqueda por nombre del plan"
                                @keydown.enter.native="buscarPlanes()"
                            ></b-form-input>

                            <b-button size="sm"
                                      variant="info"
                                      style="margin: auto;"
                                      @click="buscarPlanes()">
                              <span v-if="!loader"><em class="buscar_svg" style="height: 16px;"></em></span>
                              <span v-else><b-spinner small></b-spinner></span>
                            </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <b-button-group style="display: flex; margin: auto;">
                    <b-button class="button-dentalia-svg-1 ml-2 mt-2" variant="primary"
                              title="Crear un nuevo plan"
                              @click="ruta()"
                              style="width: 38px; height: 38px;"
                    >
                      <em class="diente_tabla_svg" style="width: 25px; height: 25px;"></em>
                    </b-button>
                  </b-button-group>
                  <b-col></b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="contenedorTablaSinColor">
              <b-col cols="12">
                <b-table
                    id="Pendientes"
                    thead-tr-class="columnasTablaSinColor"
                    :items="items"
                    :fields="fields"
                    :per-page="registrosPorPagina"
                    :current-page="paginaActual"
                    responsive="true"
                    class="parrafos"
                    fixed>
                  <template v-slot:cell(estatus)="row">
                    <span v-if="row.item.suspendido" >Suspendido</span>
                    <span v-else>{{row.item.estatus}}</span>
                  </template>
                  <template v-slot:cell(Acciones)="row">
                    <b-button-group>
                      <b-button
                        v-if="$localStorageService.can('BO_13_mod_plan_conv')"
                        size="sm" variant="warning" class="mt-1 marginbotones "
                        style="border-radius:15px; width: 30%;"
                        @click="modificar(row.item)"
                        ><em class="editar_svg sm" v-b-popover.hover.top="'Editar plan'"></em>
                      </b-button>
                      <b-button
                        v-if="row.item.suspendido === true && $localStorageService.can('BO_13_mod_plan_conv')"
                        size="sm" variant="success" class="mt-1 marginbotones "
                        style="border-radius:15px; width: 30%;"
                        v-b-popover.hover.top="'Activar plan'"
                        @click="suspender(row.item)"
                        >
                        <em class="documento_x_svg sm" style="padding-top: 3px;"></em>
                      </b-button>
                      <b-button
                        v-if="row.item.suspendido === false && $localStorageService.can('BO_13_mod_plan_conv')"
                        size="sm" variant="danger" class="mt-1 marginbotones "
                        style="border-radius:15px; width: 30%;"
                        v-b-popover.hover.top="'Suspender plan'"
                        @click="suspender(row.item)"
                        >
                        <em class="documento_x_svg sm" style="padding-top: 3px;"></em>
                      </b-button>
                      <b-button
                        v-if="$localStorageService.can('BO_13_detalle_plan_conv')"
                        size="sm" variant="primary" class="mt-1 marginbotones "
                        style="border-radius:15px; width: 30%;"
                        v-b-popover.hover.top="'Detalle de plan'"
                        @click="abrirModal(row.item)"
                        >
                        <em class="ojo_svg sm"></em>
                      </b-button>
                      <b-dropdown id="dropdown-1" size="sm" variant="link" no-caret>
                        <template #button-content>
                          <em class="tres_puntos_svg sm" style="height: 16px; width: 6px;"></em>
                        </template>
                        <b-dropdown-item v-if="$localStorageService.can('BO_13_detalle_plan_conv')" @click="abrirModalDuplicar(row.item)">Duplicar plan</b-dropdown-item>
                        <b-dropdown-item v-if="row.item.estatus === 'Activo' && $localStorageService.can('BO_13_baja_plan')" @click="eliminar(row.item)">Eliminar plan</b-dropdown-item>
                        <b-dropdown-item v-if="row.item.estatus !== 'Activo' && $localStorageService.can('BO_13_baja_plan')" @click="eliminar(row.item)">Activar perfil</b-dropdown-item>
                      </b-dropdown>
                    </b-button-group>

                  </template>
                </b-table>
                <div align="center" v-if="loader">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </div>
                <b-col v-if="!loader">
                  <b-alert v-if="items.length === 0" variant="warning" show>No hay datos</b-alert>
                </b-col>
                <b-col v-if="!loader">
                  <b-pagination
                      v-if="items !== undefined && items.length > 10"
                      align="center"
                      v-model="paginaActual"
                      :total-rows="items.length"
                      :per-page="registrosPorPagina"
                      aria-controls="my-table1"
                  ></b-pagination>
                </b-col>
              </b-col>


            </b-row>

          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
        v-model="show"
        size="xl"
        hide-footer
    >
      <template #modal-header class="w-100" style="color: white">
        <div class="d-flex">
          <em class="tabla_diente_svg icon-boton mr-2" style="width: 1.6em; height: 1.6em;"></em>
          <p style="color: white; font-size: 1.2em; font-weight: 600;">Detalle del plan</p>
        </div>
        <em class="close_x_gray" style="width: 10px; cursor: pointer" close @click="show = false"></em>
      </template>
      <DetallePlanV2 :empresaActual="empresaActual"/>
    </b-modal>
    <b-modal
        v-model="blnModalDuplicado"
        title="Duplicar Plan"
        no-close-on-backdrop
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <label>Nombre
                  <validacion/>
                </label>

                  <b-form-input id="nombreGrupo" name="nombreMenu" placeholder="Nombre del perfil"
                                v-model="duplicado.numbre"
                  ></b-form-input>
              </b-form-group>
              <b-form-group align="left">
                <label for="trtsg">Cuenta</label>
                <validacion/>
                  <v-select id="trtsg" name="trtsg"
                            placeholder="Cuenta"
                            v-model="duplicado.cuenta"
                            label="nombreCuenta"
                            :reduce="(variable) => variable.idCuenta"
                            :options="cuentas"
                            style="width: 95%"
                  ></v-select>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardarDuplicado()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../components/Header";
import DetallePlanV2 from "../ventas/plan/DetallePlanV2.vue";

export default {
  name: "planesIndex",
  components: {
    Header,
    DetallePlanV2,
  },
  data: function () {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      registrosPorPagina: 10,
      paginaActual: 0,
      fields: [
        {key: "idPlan", label: "ID"},
        {key: "nombre", label: "Nombre"},
        {key: "nombreCuenta", label: "Cuenta"},
        {key: "tipo", label: "Tipo"},
        {key: "estatus", label: "Estatus"},
        "Acciones",
      ],
      items: [],
      loader: false,
      show: false,
      idSeleccionado: null,
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null
      },
      blnModalDuplicado: false,
      duplicado: {
        idPlan: null,
        numbre: null,
        cuenta:null,
      },
      cuentas:[],
      loaderAcciones: false,

      empresaActual: null,
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.buscarPlanes();
    this.obtenerCuentas();
  },
  methods: {
    buscarPlanes() {
      this.loader = true
      this.$http.post(this.$api + 'planConvenio/obtener/planes', this.filtro).then(respuesta => {
            if (respuesta.data.data) {
              this.items = respuesta.data.data
            }

          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },
    ruta() {
      this.$router.push({
        name: "PlanConvenio"
      });
    },
    modificar(item) {
      this.$router.push({
            name: 'PlanConvenioModificar',
            params: {id: item.idPlan}
          }
      )
    },
    detalle(item, button) {
      this.titulo = 'Detalle del plan ' + item.nombre;
      this.informacionModal.idmodal = "modalDetalle";
      this.informacionModal.objetoColaborador = "";
      this.informacionModal.crear = true;
      this.plan = {
        id: null,
        nombre: null,
        area: null,
        cobertura: null,
        tipo: null,
        precio: null,
        descripcion: null,
        requisitos: null,
        fechaInicio: null,
        fechaFin: null,
        estatus: null
      };
      this.plan = JSON.parse(JSON.stringify(item));
      this.$root.$emit(
          "bv::show::modal",
          this.informacionModal.idmodal,
          button
      );
    },
    obtenerCuentas() {
      this.$http.get(this.$api + 'planConvenio/obtener/cuentas').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.cuentas.push(it);
              })
            }
          }
      )
    },
    guardarDuplicado(){
      this.loaderAcciones = true,
      this.$http.post(this.$api + 'planConvenio/duplicar',this.duplicado).then(respuesta => {
            if (respuesta.data.data) {
              this.blnModalDuplicado =false;
              this.$swal.fire({
                icon: "success",
                title: "Aviso",
                text: 'Duplicado guardado con éxito',
              });
              this.buscarPlanes();
            }
          }
      ).finally(() => {
        this.loaderAcciones = false;
      })
    },
    eliminar(item) {

      const mensaje = item.estatus === 'Activo' ? "¿Está seguro de eliminar el plan?" : "¿Está seguro de activar el plan?";
      const mensajeExito = item.estatus === 'Activo' ? "Plan desactivado correctamente" : "Plan activado con éxito";
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.$http.delete(this.$api + 'planConvenio/plan/eliminar?plan=' + item.idPlan).then(respuesta => {
                if (respuesta.data.data) {
                  const index = this.items.indexOf(item);
                  this.$swal.fire({
                    icon: "success",
                    title: "Aviso",
                    text: mensajeExito,
                  });
                  this.items[index].estatus = item.estatus === 'Activo' ? "Desactivado" : 'Activo';
                }
              }
          )
        }
      })
    },
    suspender(item) {

      const mensaje = item.suspendido === false ? "¿Está seguro de suspender el plan?" : "¿Está seguro de activar el plan?";
      const mensajeExito = item.suspendido === false ? "Plan suspendo correctamente" : "Plan activado con éxito";
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.$http.put(this.$api + 'planConvenio/suspendido?idPlan=' + item.idPlan).then(respuesta => {
                if (respuesta.data.data) {
                  const index = this.items.indexOf(item);
                  this.$swal.fire({
                    icon: "success",
                    title: "Aviso",
                    text: mensajeExito,
                  });
                  this.items[index].suspendido = !item.suspendido;
                }
              }
          )
        }
      })
    },
    abrirModalDuplicar(item){
      this.duplicado.idPlan = item.idPlan
      this.duplicado.numbre = item.nombre + ' (Copia)'
      this.duplicado.cuenta = item.cuenta

      this.blnModalDuplicado =true;
    },
    abrirModal(item) {
      const idPlan = item.idPlan;
      const parametros = { idPlan: parseInt(idPlan, 10) };
      this.$http.post(this.$api + "empresas/detallePlan", parametros).then((response) => {
        if (response.data.data) {
          this.empresaActual = response.data.data;
          this.empresaActual.idPlan = this.empresaActual.idPlan.toString();
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(() => {
        this.loading = false;
      });


      this.idSeleccionado = item.idPlan;
      setTimeout(() => {
        this.show = true
      }, 500);
    },
    cerrarModal() {
      this.show = false;
      this.blnModalDuplicado = false;
    }
  }
}
</script>

<style scoped>
</style>
